import React from "react";
import { MainProfileBg, MainUpload, MainUploadBtn } from "components/common";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import heroImg from "assets/heroImg.png";

import { NftForms } from "components/common/InputField/inputElement";
import { ErrorMessage } from "components/nftForm/nftFormElement";

type Props = {
  collectionProfileBg?: boolean;
  createUploadBtn?: boolean;
  featuredUploadBtn?: boolean;
  bannerUploadBtn?: boolean;
  collectionFeaturedImage?: boolean;
  collectionBannerImage?: boolean;
  uploadLabel?: string;
  inputLabelText?: string;
  inputRequired?: boolean;
  profileSettingBanner?: boolean;
  profileSettingBannerBtn?: boolean;
  setValue?: any;
  bgimg?: any;
  error?: string;
};

const UploadField: React.FC<Props> = ({
  collectionProfileBg,
  createUploadBtn,
  collectionFeaturedImage,
  collectionBannerImage,
  uploadLabel,
  inputLabelText,
  inputRequired,
  featuredUploadBtn,
  bannerUploadBtn,
  profileSettingBanner,
  profileSettingBannerBtn,
  setValue,
  bgimg,
  error,
}: {
  collectionProfileBg?: boolean;
  createUploadBtn?: boolean;
  collectionFeaturedImage?: boolean;
  collectionBannerImage?: boolean;
  setValue?: any;
  uploadLabel?: string;
  inputLabelText?: string;
  inputRequired?: boolean;
  featuredUploadBtn?: boolean;
  bannerUploadBtn?: boolean;
  profileSettingBanner?: boolean;
  profileSettingBannerBtn?: boolean;
  bgimg?: any;
  error?: string;
}) => {
  const upload = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    onchange: (e: any) => {
      setValue(e);
    },
  };

  return (
    <div>
      <NftForms.Group>
        <NftForms.Label style={{ marginTop: "1rem", color: "black" }}>
          {" "}
          {uploadLabel}
          {inputRequired ? (
            <span
              style={{ color: "red", marginLeft: "0.2rem", marginTop: "5rem" }}
            >
              *
            </span>
          ) : (
            ""
          )}
        </NftForms.Label>
        <br />

        <NftForms.Text className="text-muted">{inputLabelText}</NftForms.Text>
        <MainProfileBg
          collectionProfileBg={collectionProfileBg}
          collectionFeaturedImage={collectionFeaturedImage}
          collectionBannerImage={collectionBannerImage}
          profileSettingBanner={profileSettingBanner}
          bgImg={bgimg}
        >
          <MainUpload
            onChange={(e) => setValue(e)}
            beforeUpload={() => false}
            {...upload}
          >
            <MainUploadBtn
              icon={<EditOutlined />}
              createUploadBtn={createUploadBtn}
              featuredUploadBtn={featuredUploadBtn}
              bannerUploadBtn={bannerUploadBtn}
              profileSettingBannerBtn={profileSettingBannerBtn}
            >
              {" "}
            </MainUploadBtn>
          </MainUpload>
        </MainProfileBg>
        {error ? <ErrorMessage>{error}</ErrorMessage> : ""}
      </NftForms.Group>
    </div>
  );
};

export default UploadField;
